/**
 * WPS Pages Internal Editor
 * Based on AlpineBlocks, simplified for template-only use
 */

// Use globally available Alpine.js
const Alpine = window.Alpine;

// Import modular components
import { registerAlpineComponents } from './core/AlpineComponents';
import { setupGlobalAPI } from './core/GlobalAPI';
import { MediaPicker } from './core/MediaPicker.js';
import TinyMCEEditor from './editors/TinyMCEEditor';
import { resolveTemplate, resolveTemplateSchema } from './utils/TemplateSchemaResolver.js';

// Register MediaPicker component immediately
MediaPicker.registerAlpineComponent();

// Setup global AlpineBlocks API
window.AlpineBlocks = window.AlpineBlocks || {};
window.AlpineBlocks.RichTextEditor = TinyMCEEditor; // Export as RichTextEditor for backward compatibility

// Template schema lookup, exposed globally for inline JS and x-data template strings
window.WpsTemplateSchemaResolver = { resolveTemplate, resolveTemplateSchema };

// Register Turbo lifecycle hooks once at startup
TinyMCEEditor.setupTurboCompatibility();

// Dispatch ready event
window.dispatchEvent(new CustomEvent('alpineblocks:ready'));

// Register all Alpine components
registerAlpineComponents();

// Setup global API
setupGlobalAPI();

// Export AlpineBlocks class
import AlpineBlocks from './core/AlpineBlocksClass';
export default AlpineBlocks;
